import React from 'react';
import { FestivalData } from '../../../../model/FestivalData';
import PageHeader from '../../../../components/PageHeader';
import { useMessages } from '../../../../i18n/I18n';
import './TicketsEditor.css';

interface TicketsEditorProps {
  tickets: FestivalData['infos']['tickets'];
  onChange: (newTickets: NonNullable<FestivalData['infos']['tickets']>) => void;
  getApiImageUrl: (identifier: string) => string;
}

const TicketsEditor: React.FC<TicketsEditorProps> = ({ tickets, onChange }) => {
  const t = useMessages('tickets');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    onChange({
      ...tickets!,
      [name]: value
    });
  };

  return (
    <section className="tickets-editor">
      <PageHeader
        title={t.title}
        description={t.description}
      />

      <div className="tickets-card">
        <div className="tickets-field">
          <label htmlFor="ticket_description">{t.descriptionLabel}</label>
          <textarea
            id="ticket_description"
            name="description"
            value={tickets?.description || ''}
            onChange={handleChange}
            rows={4}
            aria-describedby="ticket_description_help"
          />
          <span id="ticket_description_help" className="tickets-help">
            {t.descriptionHelp}
          </span>
        </div>
        <div className="tickets-field">
          <label htmlFor="ticket_link">{t.link}</label>
          <input
            placeholder='https://www.ticketmaster.fr/event/1234567890'
            id="ticket_link"
            type="text"
            name="link"
            value={tickets?.link || ''}
            onChange={handleChange}
          />
          <span className="tickets-help">{t.linkHelp}</span>
        </div>
      </div>
    </section>
  );
};

export default TicketsEditor;
